import { useQueryAccessRequestByLocationQuery } from '../../__generated__/chirp/com/hubspot/permissionsmanagement/accessrequest/rpc/AccessRequestRpc.hooks';
export function useExistingPermissionAccessRequestQuery({
  appLocationId
}) {
  var _data$request;
  const shouldSkip = !appLocationId;
  const {
    data,
    loading,
    refetch
  } = useQueryAccessRequestByLocationQuery({
    variables: {
      appLocationId: appLocationId !== null && appLocationId !== void 0 ? appLocationId : ''
    },
    skip: shouldSkip
  });
  return {
    existingPermissionAccessRequest: shouldSkip ? null : (_data$request = data === null || data === void 0 ? void 0 : data.request) !== null && _data$request !== void 0 ? _data$request : null,
    isExistingPermissionAccessRequestLoading: !shouldSkip && loading,
    refetchExistingPermissionAccessRequest: () => {
      void refetch();
    }
  };
}